import { Button, useTheme } from '@mui/material';
import { ColorDot } from 'apps/app/src/components/design/ColorDot';
import { useHubspotAuthRedirect } from 'apps/app/src/hooks/requests/use-hubspot-auth-redirect';
import { runMutation } from 'apps/app/src/utils/vy-mutation';
import HubSpot from '../../../../../assets/images/hubspot-logo.png';

type HubSpotButtonProps = { 
  isConnected: boolean;
};

export function HubSpotButton({ isConnected }: HubSpotButtonProps) {
  const vyTheme = useTheme();
  const connectHubspotMutation = useHubspotAuthRedirect();
  
  const handleConnectClick = async () => {
    await runMutation(
      connectHubspotMutation, undefined,
      {
        pending: 'Connecting...',
        success: 'Connected',
        error: 'Failed to connect',
      },
    );
  };

  return (
    <>
      <div
        className="flex items-center justify-between gap-2"
        key="HubSpot"
      >
        <div className="flex items-center gap-3">
          <ColorDot color={isConnected ? vyTheme.palette.success.main : vyTheme.palette.grey[300]}/>
          <div className="flex h-12 w-16 items-center justify-center">
            <HubspotIcon/>
          </div>
          <h2>HubSpot</h2>
         
        </div>
        {isConnected ? (
          <Button 
            variant='outlined'
            size='small'
            color='error'
          >
            Disconnect
          </Button>
        ) : (
          <Button 
            variant='outlined'
            size='small'
            color='success'
            onClick={() => handleConnectClick()}
          >
            Connect
          </Button>
        )}
      </div>
    </>
  );
}

const HubspotIcon = () => (
  <img
    className="cursor-pointer"
    src={HubSpot}
    alt="HubSpot"
  />
);